// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-page-header-no-padding{padding:0}.osui-page-header .ant-page-header-back-button,.osui-page-header .ant-page-header-heading-title{font-size:var(--page-header-title-font-size);font-weight:var(--page-header-title-font-weight)}.osui-page-header .ant-page-header-back-button .osui-icon{height:var(--page-header-title-font-size)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
